import React, { useState } from "react";
import Header from "./components/Sidebar/Header";
import Input from "./components/Sidebar/Input";
import Fact from "./components/Sidebar/Fact";
import DownloadImage from "./components/Sidebar/DownloadImage";
import Footer from "./components/Sidebar/Footer";
import "./styles/global.scss";

import HumanGamesLogo from "./images/human.games.png"

import SearchEngineOptimisation from "./components/SearchEngineOptimisation"

import loadable from "@loadable/component";

const LoadablePixiApp = loadable(() => import("./components/Render/Render"), {
  fallback: <div>Loading...</div>,
});

const App = () => {
  const [app, setApp] = useState(null);
  const [settings, setSettings] = useState({
    firstValue: 490.7,
    firstUnit: "YB",
    firstLabel: "Average US Household",
    secondValue: 5,
    secondUnit: "ZB",
    secondLabel: "NSA Utah Data Center",
  });

  const title = 'How Much Data Is That'
  const canonicalURL = 'https://human.games/how-much-data-is-that'
  const description = 'A comparison tool for visualising different sizes of data. Compare bytes, megabytes, gigabytes, terrabytes, yottabytes and see the difference.'
  const keywords = 'visualisation data comparison datasize bytes megabytes gigabytes terrabytes yottabytes compared'

  return (
    <main>
       <SearchEngineOptimisation
          title={title}
          description={description}
          path="/"
          keywords={keywords}
          schemaMarkup={{
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": {title},
            "url": {canonicalURL},
            "description": {description},
            "applicationCategory": "Tool",
            "applicationSubCategory": "Visualisation",
            "contentRating": "Everyone",
            "author": {
              "@type": "Person",
              "name": "Human Games UK",
              "url": "https://human.games/"
            },
          }}
        />
      <div className="body">
        <aside>
          <div className="humangames">
            <a href={"https://human.games/"} rel="dofollow">
              <img src={HumanGamesLogo} alt="human games logo" />
            </a>
          </div>
          <Header />
          <Fact />
          <Input settings={settings} setSettings={setSettings} />
          <DownloadImage app={app} />
          <Footer className="hidden-small" />
        </aside>
        <main>
          <LoadablePixiApp settings={settings} setApp={setApp} />
        </main>
        <Footer className="hidden-large" />
      </div>
    </main>
  );
};

export default App;
